import { useState, useEffect, useRef, ReactNode, Children } from "react";

interface CarouselProps {
  children: ReactNode;
  visibleItems?: number;
  gap?: number;
  autoPlay?: boolean;
  autoPlayInterval?: number;
}

const Carousel: React.FC<CarouselProps> = ({
  children,
  visibleItems = 1,
  gap = 16,
  autoPlay = false,
  autoPlayInterval = 3000,
}) => {
  const items = Children.toArray(children).filter(child => typeof child !== 'string');
  const totalItems = items.length;
  const [currentIndex, setCurrentIndex] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  // Auto-play
  useEffect(() => {
    if (!autoPlay) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalItems);
    }, autoPlayInterval);
    return () => clearInterval(interval);
  }, [autoPlay, autoPlayInterval, totalItems]);

    const maxIndex = Math.max(totalItems, 0);

  const prev = () => setCurrentIndex((prev) => (prev === 0 ? maxIndex : prev - 1));
  const next = () => setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    
  const childWidth = `${100 / visibleItems}%`;

  return (
    <div className="relative w-full overflow-hidden">
      <div
        ref={containerRef}
        className="flex transition-transform duration-500 ease-in-out"
        style={{
          transform: `translateX(-${(currentIndex * 100) / totalItems}%)`,
          gap: `${gap}px`,
        }}
      >
        {items.map((child, idx) => (
          <div key={idx} className="flex-shrink-0" style={{ width: childWidth }}>
            {child}
          </div>
        ))}
      </div>

      <button
        onClick={prev}
        className="absolute left-2 top-1/2 -translate-y-1/2 bg-black text-white p-2 rounded-full opacity-70 hover:opacity-100 transition"
      >
        &#10094;
      </button>
      <button
        onClick={next}
        className="absolute right-2 top-1/2 -translate-y-1/2 bg-black text-white p-2 rounded-full opacity-70 hover:opacity-100 transition"
      >
        &#10095;
      </button>
    </div>
  );
};

export default Carousel;
